import { getClient } from "./contentful-client";

export async function fetchContent() {
  const client = getClient();
  const request = await client.getEntries();

  return {
    response: request
  };
}

export function mapContent(data) {
  console.log(data);

  const content = { classes: [], events: [] };

  data.items.forEach(entry => {
    if (entry.sys.contentType.sys.id === "class") {
      content.classes.push(entry.fields);
    } else if (entry.sys.contentType.sys.id === "contactDetails") {
      content.contact = entry.fields;
    } else if (entry.sys.contentType.sys.id === "gallery") {
      content.gallery = entry.fields;
    } else if (entry.sys.contentType.sys.id === "event") {
      const endDateTime = new Date(entry.fields.endDateTime);
      const now = new Date();

      if (endDateTime > now) {
        content.events.push(entry.fields);
      }
    } else if (entry.sys.contentType.sys.id === "section") {
      if (entry.fields.type === "About") {
        content.aboutSection = entry.fields;
      } else if (entry.fields.type === "Classes") {
        content.classesSection = entry.fields;
      } else if (entry.fields.type === "Events") {
        content.eventsSection = entry.fields;
      } else if (entry.fields.type === "Contact") {
        content.contactSection = entry.fields;
      } else if (entry.fields.type === "Offers") {
        content.offersSection = entry.fields;
      }
    }
  });

  return content;
}
